import React from 'react';
import { Link } from 'react-router-dom';
import {
  CheckCircle,
  ArrowRight
} from 'lucide-react';

const EmailVerified: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
            <CheckCircle className="h-12 w-12 text-green-600" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Email Doğrulandı!
          </h1>

          {/* Description */}
          <p className="text-lg text-gray-600 mb-8">
            Email adresiniz başarıyla doğrulandı. Artık Avukasa'yı kullanmaya başlayabilirsiniz.
          </p>

          {/* Features */}
          <div className="bg-white rounded-lg shadow-sm border p-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Artık yapabilecekleriniz:
            </h3>
            <ul className="space-y-3 text-left">
              <li className="flex items-center text-gray-600">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                Email hesaplarınızı bağlayın
              </li>
              <li className="flex items-center text-gray-600">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                Mail takip sistemi kurun
              </li>
              <li className="flex items-center text-gray-600">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                DOCX şablonlarınızı yükleyin
              </li>
              <li className="flex items-center text-gray-600">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                Otomatik döküman oluşturun
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link
              to="/onboarding"
              className="w-full flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              Başlayalım
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>

            <Link
              to="/login"
              className="w-full flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              Giriş Yap
            </Link>
          </div>

          {/* Help Text */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Sorun mu yaşıyorsunuz?{' '}
              <Link to="/feedback" className="text-blue-600 hover:text-blue-500 font-medium">
                Bizimle iletişime geçin
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerified;
